import styles from './NoAccess.module.scss';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@cas/components/error-page/ErrorPage';
import { VdsButton } from '@volt/volt-extended-components-react';
import { ExternalUrl } from '@cas/config/links';

export function NoAccess() {
  const { t } = useTranslation();

  return (
    <ErrorPage
      title={t('Not authorized')}
      message={t('No access')}
      actions={
        <a
          className={styles.link}
          href={ExternalUrl.MiningContact}
          target="_blank"
          rel="noopener noreferrer"
        >
          <VdsButton variant="primary" size="large" danger onClick={() => undefined} isFullWidth>
            {t('RequestAccess')}
          </VdsButton>
        </a>
      }
    />
  );
}

export default NoAccess;
